import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {CompanyTypeService, LibraryService, LoadingSpinnerService} from '../../services';
import {Library} from '../../models';
import {ActivatedRoute} from '@angular/router';
import {LibraryType} from '../../enums/library-type/library-type';

@Component({
    selector: 'app-page-opportunities-library',
    templateUrl: './page-opportunities-library.component.html',
    styleUrls: ['./page-opportunities-library.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageOpportunitiesLibraryComponent implements OnInit {
    private libraryService = inject(LibraryService);
    private companyTypeService = inject(CompanyTypeService);
    private route = inject(ActivatedRoute);
    public loadingSpinnerService = inject(LoadingSpinnerService);

    public opportunitiesLibrary: Library;
    private companyTypeId: number;

    ngOnInit(): void {
        this.setData();
        this.loadLibrary();
    }

    private setData() {
        this.companyTypeId = parseInt(this.route.snapshot.paramMap.get('companyTypeId'), 10);
        this.companyTypeService.setActiveCompanyTypeId(this.companyTypeId);
    }

    private loadLibrary() {
        this.loadingSpinnerService.show();
        this.libraryService.getLibrary(this.companyTypeId, LibraryType.OPPORTUNITIES).then((library) => {

            this.opportunitiesLibrary = library;
        }).finally(() => {
            this.loadingSpinnerService.hide();
        });
    }
}
